export enum UserRole {
  USER = 'USER',
  STORE_MANAGER = 'STORE_MANAGER',
  STORE_ADMIN = 'STORE_ADMIN',
  CLUB_ADMIN = 'CLUB_ADMIN',
  COMMUNITY_MANAGER = 'COMMUNITY_MANAGER',
  ADMIN = 'ADMIN',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  SUPERADMIN = 'SUPERADMIN',
}

// Export club types
export * from './clubs';

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  loyaltyNumber: string;
  birthDate?: string;
  avatarUrl?: string;
  role?: UserRole;
  storeId?: string | null;
  clubId?: string | null;
  preferredCity?: string | null;
  createdAt: string;
  totalRides?: number;
}

export interface Store {
  id: string;
  name: string;
  location?: string;
  address?: string;
  phone?: string;
  email?: string;
  isActive: boolean;
  trialEndsAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface Bike {
  id: string;
  userId: string;
  make: string;
  model: string;
  components?: string;
  kilometersTracked: number;
  isActive: boolean;
  createdAt: string;
}

export interface Ride {
  id: string;
  name: string;
  description?: string;
  departureDate: string;
  departureTime?: string;
  departureLocation: string;
  distanceKm: number;
  elevationGainM?: number;
  estimatedDurationMinutes?: number;
  maxRiders: number;
  storeId?: string | null; // Store that created this ride (optional, can be club ride)
  clubId?: string | null; // Club that created this ride (optional, can be store ride)
  visibility?: 'PUBLIC' | 'MEMBERS_ONLY' | 'INVITE_ONLY'; // Ride visibility (CLUB_PREMIUM feature)
  storeLocation?: string; // Legacy field, kept for backward compatibility
  cost: number;
  stravaUrl?: string;
  rideType?: 'GRAVEL' | 'MTB' | 'ROAD' | null;
  gpxFileUrl?: string;
  loyaltyPoints?: number;
  isCompleted?: boolean;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
  participantCount: number;
  isParticipant?: boolean;
  participants?: RideParticipant[];
  store?: Store; // Store details if included
}

export interface RideParticipant {
  id: string;
  rideId: string;
  userId: string;
  joinedAt: string;
  checkedIn?: boolean;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    avatarUrl?: string;
  };
}

export interface Friend {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  avatarUrl?: string;
  loyaltyNumber: string;
  friendshipId: string;
  friendsSince: string;
}

export interface FriendRequest {
  id: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    avatarUrl?: string;
  };
  createdAt: string;
}

export interface Message {
  id: string;
  conversationId: string;
  senderId: string;
  content: string;
  createdAt: string;
  sender?: {
    id: string;
    firstName: string;
    lastName: string;
    avatarUrl?: string;
  };
}

export interface Conversation {
  id: string;
  participantIds: string[];
  lastMessage?: Message;
  unreadCount?: number;
  participants?: Array<{
    id: string;
    firstName: string;
    lastName: string;
    avatarUrl?: string;
  }>;
  updatedAt: string;
}

export interface NewsItem {
  id: string;
  title: string;
  content: string;
  imageUrl?: string;
  imageFocalPointY?: number | null;
  type?: string;
  storeId?: string;
  storeLocation?: string; // Legacy field
  isActive: boolean;
  createdAt: string;
  store?: Store;
}

export interface LoyaltyPoint {
  id: string;
  userId: string;
  points: number;
  reason: string;
  rideId?: string;
  createdAt: string;
}
